// IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: импорт записей — меню и вставка)
// Пункт «Import records» меню пользователя (AppTopbar.vue, секция Widgets, после «Import widget (JSON)»): открыть форму задачи импорта записей
// (сегмент TASKS-records-import). В буфере записи (Deep copy грида / карточки — чип CHIP-Records; Copy record — CHIP-Record; Copy rows — CHIP-Rows;
// голый список записей или одна запись { id, segment, … }) → бэк (метод records_import_prepare, common_modules/chip.py) создаёт задачу с этими
// строками и отвечает командой widget_open — форма открывается заполненной. Буфер пуст / не JSON и не python-литерал / без записей / нет доступа к
// буферу → пустая форма той же задачи (новая запись сегмента) и подсказка. Флаг fe.ux.importRecordsMenu (по умолчанию ВКЛ): выключен — пункта нет,
// меню как было. Роль «только чтение»: метод importRecords подпадает под /^(paste|import)/ (readonlyPolicy.js ro_allowsAction) — пункт скрыт и
// отклоняется до чтения буфера; бэк держит records_import_prepare в DENIED_BACKEND_METHODS. Чистые функции — для tests/unit/importRecords.test.mjs
export const IMPORT_RECORDS_MENU_FLAG = 'fe.ux.importRecordsMenu'
export const IMPORT_RECORDS_SEGMENT = 'TASKS-records-import'
export const IMPORT_RECORDS_BACKEND_METHOD = 'records_import_prepare'
export const IMPORT_RECORDS_NORMALIZE_METHOD = 'records_import_normalize'   // IE 2026 10 28 / ODOO-349799 (PR5): вставка / файл в таблицу Records Import — формат разбирает бэк
export const RECORD_CHIPS = ['CHIP-Records', 'CHIP-Record', 'CHIP-Rows', 'CHIP-Widget']   // IE 2026 10 28 / ODOO-349799 (PR5): + CHIP-Widget

const isObj = (v) => v !== null && typeof v === 'object' && !Array.isArray(v)
const isRecordLike = (v) => isObj(v) && v.id !== undefined && v.id !== null && v.id !== '' && typeof v.segment === 'string' && v.segment !== ''

// флаг: setting(k, def) — store.setting; без функции или с ошибкой чтения — ВКЛ (дефолт), выключен только явным false
export function importRecordsMenu_on(setting) {
    try { return typeof setting !== 'function' || setting(IMPORT_RECORDS_MENU_FLAG, true) !== false } catch (e) { return true }
}

// содержимое буфера (уже разобранное store.parseClipboardWidget) → { kind, chip, items }
//   kind 'records'     — chip (что уходит бэку) и items (записи / строки с id и segment; строки без них отброшены)
//   kind 'not_records' — разобралось, но записей нет (чип виджета, список виджетов, чужой JSON, пустой список)
export function importRecords_chipRecords(content) {
    if (Array.isArray(content)) {
        const items = content.filter(isRecordLike)
        return items.length ? { kind: 'records', items, chip: { title: '', segment: 'CHIP-Records', doc: { data: items } } } : { kind: 'not_records', items: [], chip: null }
    }
    if (!isObj(content)) return { kind: 'not_records', items: [], chip: null }
    const seg = content.segment
    if (seg === 'CHIP-Records' || seg === 'CHIP-Rows') {
        const items = (Array.isArray(content.doc?.data) ? content.doc.data : []).filter(isRecordLike)
        return items.length ? { kind: 'records', items, chip: { ...content, doc: { ...content.doc, data: items } } } : { kind: 'not_records', items: [], chip: null }
    }
    if (seg === 'CHIP-Record') {
        const rec = content.doc?.record
        return isRecordLike(rec) ? { kind: 'records', items: [rec], chip: content } : { kind: 'not_records', items: [], chip: null }
    }
    if (seg === 'CHIP-Widget') {   // IE 2026 10 28 / ODOO-349799 (PR5): скопированный / сохранённый в файл виджет — запись каталога в doc.WIDGET.record (бэк дочитывает по meta.source.record, если её нет)
        const rec = content.doc?.WIDGET?.record
        const src = content.meta?.source?.record
        if (isRecordLike(rec)) return { kind: 'records', items: [rec], chip: content }
        return isRecordLike(src) ? { kind: 'records', items: [src], chip: content } : { kind: 'not_records', items: [], chip: null }
    }
    if (typeof seg === 'string' && seg.startsWith('CHIP-')) return { kind: 'not_records', items: [], chip: null }   // CHIP-Widget, CHIP-Cell …
    // голая запись (JSON одной записи из карточки / файла): id + segment + doc
    if (isRecordLike(content) && isObj(content.doc)) return { kind: 'records', items: [content], chip: { title: content.title || '', segment: 'CHIP-Record', doc: { record: content } } }
    return { kind: 'not_records', items: [], chip: null }
}

// IE 2026 10 27 / ODOO-5800 (ревью p068 N8): python-литерал на фронте НЕ разбираем — наивная замена кавычек (store.pythonLiteralToJsObject) ломается на
// апострофах внутри строк («Ім'я», O'Brien) и меняет True / None внутри строк. FE разбирает только JSON (Deep copy пишет JSON — основной путь);
// не JSON — быстрая проверка «похоже на записи» (importRecords_looksLikeRecords) и СЫРОЙ текст уходит бэку (params.text, разбор ast.literal_eval там)
export const normalizeText = (text) => String(text).trim().replace(/^\uFEFF/, '').replace(/^(?:const|let|var)?\s*WIDGET\s*=\s*/i, '').replace(/;\s*$/, '').trim()

// «похоже на записи»: чип записей (CHIP-Records / CHIP-Record / CHIP-Rows) или словарь с ключами segment и id (в любых кавычках)
export function importRecords_looksLikeRecords(text) {
    const t = String(text || '')
    if (!/^[[{]/.test(t)) return false
    if (/['"]CHIP-(?:Records|Record|Rows|Widget)['"]/.test(t)) return true
    return /['"]segment['"]\s*:/.test(t) && /['"]id['"]\s*:/.test(t)
}

// текст буфера → { kind: 'empty' | 'not_records' | 'records' | 'records_text', chip, items, text }
//   'records'      — JSON разобран на FE: chip уходит бэку
//   'records_text' — не JSON, но похоже на записи (python-литерал): бэку уходит сырой текст (items неизвестны)
export function importRecords_fromText(text) {
    if (text === null || text === undefined || !String(text).trim()) return { kind: 'empty', items: [], chip: null }
    const t = normalizeText(text)
    let content
    try { content = JSON.parse(t) } catch (e) {
        return importRecords_looksLikeRecords(t) ? { kind: 'records_text', items: [], chip: null, text: t } : { kind: 'not_records', items: [], chip: null }
    }
    if (content === null || content === undefined) return { kind: 'not_records', items: [], chip: null }
    return importRecords_chipRecords(content)
}

// действие «пустая форма задачи импорта» (новая запись сегмента; ветка widget_open → widget-record → new mainStore.js)
export function importRecords_emptyAction() {
    return { command: 'widget_open', widget: 'widget-record', new: true, segment: IMPORT_RECORDS_SEGMENT, _activate: true }
}

// запрос бэку: задача импорта с записями чипа (ответ — widget_open открытой задачи + notification); r — итог importRecords_fromText
// (или сам чип): JSON → params.chip, python-литерал → params.text (сырой текст буфера)
export function importRecords_backendAction(r) {
    if (r && r.kind === 'records_text') return { method: IMPORT_RECORDS_BACKEND_METHOD, params: { text: r.text } }
    return { method: IMPORT_RECORDS_BACKEND_METHOD, params: { chip: r && r.kind === 'records' ? r.chip : r } }
}

// IE 2026 10 28 / ODOO-349799 (PR5): вставка / файл в таблицу Records Import (грид chip-records): формат на фронте не разбираем — объект JSON → params.chip, иначе сырой текст → params.text;
// бэк (records_import_normalize) отвечает { rows, warning? } — готовые строки импорта
export function importRecords_normalizeAction(text, opts = null) {
    const fileName = opts && typeof opts.file_name === 'string' && opts.file_name ? opts.file_name : ''   // IE 2026 11 02 / ODOO-349799 (records-grid-prefix): имя выбранного файла — в params.file_name (бэк кладёт его в строки как _source_name)
    const withName = (params) => (fileName ? { ...params, file_name: fileName } : params)   // IE 2026 11 02 / ODOO-349799 (records-grid-prefix)
    const t = normalizeText(text)
    const raw = String(text).replace(/^\uFEFF/, '')   // IE 2026 10 28 / ODOO-349799: сырой текст бэку — без ведущего BOM (как normalizeText)
    let content
    try { content = JSON.parse(t) } catch (e) { return { method: IMPORT_RECORDS_NORMALIZE_METHOD, params: withName({ text: raw }) } }
    if (content !== null && typeof content === 'object') return { method: IMPORT_RECORDS_NORMALIZE_METHOD, params: withName({ chip: content }) }
    return { method: IMPORT_RECORDS_NORMALIZE_METHOD, params: withName({ text: raw }) }
}

// IE 2026 11 02 / ODOO-349799 (records-grid-prefix): флаг fe.ux.pasteThen (по умолчанию ВКЛ): после вставки в грид chip-records* исполнить action.then (вставить → Next одним кликом); выкл — then не исполняется
export const PASTE_THEN_FLAG = 'fe.ux.pasteThen'
export function importRecords_pasteThen_on(setting) {
    try { return typeof setting !== 'function' || setting(PASTE_THEN_FLAG, true) !== false } catch (e) { return true }
}

// IE 2026 11 02 / ODOO-349799 (insert-unbuilt-grid): флаг fe.ux.pasteUnbuiltGrid (по умолчанию ВКЛ): грид ниже сгиба окна строится только когда виден (v-visible → content_Changed_afterTimeout),
// вставка в НЕпостроенный грид (wijmo без колонок, data000 нет) падала TypeError parentItems.indexOf; вкл — перед insertAction грид прокручивается в кадр и ждётся его построение; выкл — как раньше
export const PASTE_UNBUILT_GRID_FLAG = 'fe.ux.pasteUnbuiltGrid'
export function importRecords_pasteUnbuiltGrid_on(setting) {
    try { return typeof setting !== 'function' || setting(PASTE_UNBUILT_GRID_FLAG, true) !== false } catch (e) { return true }
}
// грид построен: есть wijmo-грид с колонками и плоский массив данных data000 (insertAction читает flex.selectedRanges / get_parentItems(data000))
export function importRecords_gridBuilt(gridVue) {
    try { return !!(gridVue && gridVue.flex && gridVue.flex.hostElement && gridVue.flex.columns && gridVue.flex.columns.length > 0 && Array.isArray(gridVue.data000)) } catch (e) { return false }
}
// Прокрутить грид в кадр и дождаться построения (опрос раз в interval мс, не дольше timeout мс); если IntersectionObserver не сработал за forceAfter мс, но грид ждёт построения
// (need_content_Changed_afterTimeout) — принудительно handleVisibility(true) (тот же путь построения, что у v-visible). Возвращает Promise<boolean> — построен ли грид.
export function importRecords_ensureGridBuilt(gridVue, opts = {}) {
    const { timeout = 2000, interval = 50, forceAfter = 400, now = () => Date.now(), sleep = (ms) => new Promise(r => setTimeout(r, ms)) } = opts
    if (importRecords_gridBuilt(gridVue)) return Promise.resolve(true)
    try { gridVue?.$el?.scrollIntoView?.({ block: 'nearest' }) } catch (e) { /* грид без DOM-элемента — ждём как есть */ }
    const t0 = now()
    let forced = false
    const step = () => {
        if (importRecords_gridBuilt(gridVue)) return Promise.resolve(true)
        const dt = now() - t0
        if (dt >= timeout) return Promise.resolve(false)
        if (!forced && dt >= forceAfter && gridVue && gridVue.need_content_Changed_afterTimeout && typeof gridVue.handleVisibility === 'function') {
            forced = true
            try { gridVue.handleVisibility(true) } catch (e) { /* не вышло — ждём таймаут */ }
        }
        return sleep(interval).then(step)
    }
    return sleep(0).then(step)
}

// IE 2026 10 28 / ODOO-349799 (PR5): ответ records_import_normalize → { rows: [], warning, skipped }; не объект / нет rows — пустой итог (бэк не ответил);
// skipped — число неразрешённых связанных записей (бэк пропустил их)
export function importRecords_normalizeRows(answer) {
    const o = answer && typeof answer === 'object'
    const sk = o ? Number(answer.skipped) : 0
    return {
        rows: o && Array.isArray(answer.rows) ? answer.rows : [],
        warning: o && typeof answer.warning === 'string' ? answer.warning : '',
        skipped: Number.isFinite(sk) && sk > 0 ? Math.floor(sk) : 0,
    }
}

// IE 2026 10 28 / ODOO-349799: весь разбор ответа для стора — { rows, skipped, warning, error }; error — текст ошибки бэка (answer.error или status 'error'), иначе ''
export function importRecords_rowsFromAnswer(answer) {
    const base = importRecords_normalizeRows(answer)
    const o = answer && typeof answer === 'object'
    let error = ''
    if (o && (answer.error || answer.status === 'error')) {
        const e = answer.error
        error = typeof e === 'string' && e ? e : (e && typeof e.message === 'string' && e.message ? e.message : (typeof answer.message === 'string' && answer.message ? answer.message : 'error'))
    }
    return { ...base, error }
}

// подсказка к пустой форме (английский ключ словаря t(); переводы — i18n/messages uk / ru)
export function importRecords_emptyHint(kind, source = 'clipboard') {
    if (source === 'file') {   // IE 2026 10 28 / ODOO-349799 (PR5): пункт «Import records from file»
        if (kind === 'empty') return 'File is empty — opened an empty Records Import'
        if (kind === 'backend') return 'The backend did not prepare the import — opened an empty Records Import'
        return 'File has no records — opened an empty Records Import'
    }
    if (kind === 'empty') return 'Clipboard is empty — opened an empty Records Import'
    if (kind === 'no_access') return 'No access to the clipboard — opened an empty Records Import'
    if (kind === 'backend') return 'The backend did not prepare the import — opened an empty Records Import'
    return 'Clipboard has no records (use Deep copy in a list or a record) — opened an empty Records Import'
}

// весь сценарий пункта меню; env: { readText, openEmpty(hintKey), prepare(r, onAnswer), openAnswer(answer) } — внедряются стором (и подменяются тестом).
// Возвращает промис с итогом { kind, count } — для теста и логов
export function importRecords_run(env) {   // IE 2026 10 28 / ODOO-349799 (PR5): env.source === 'file' — подсказки про файл
    const done = (kind, count = 0) => ({ kind, count })
    let p
    try { p = Promise.resolve(env.readText()) } catch (e) { p = Promise.reject(e) }
    return p.then(
        (text) => {
            const r = importRecords_fromText(text)
            if (r.kind !== 'records' && r.kind !== 'records_text') { env.openEmpty(importRecords_emptyHint(r.kind, env.source)); return done(r.kind) }
            return new Promise((resolve) => {
                env.prepare(r, (answer) => {
                    if (answer && typeof answer === 'object' && answer.command) { env.openAnswer(answer); resolve(done('records', r.items.length)) }
                    else { env.openEmpty(importRecords_emptyHint('backend', env.source)); resolve(done('backend', r.items.length)) }
                })
            })
        },
        () => { env.openEmpty(importRecords_emptyHint('no_access')); return done('no_access') },
    )
}

export default {
    IMPORT_RECORDS_MENU_FLAG, IMPORT_RECORDS_SEGMENT, IMPORT_RECORDS_BACKEND_METHOD, IMPORT_RECORDS_NORMALIZE_METHOD, RECORD_CHIPS,
    importRecordsMenu_on, importRecords_chipRecords, importRecords_looksLikeRecords, importRecords_fromText, importRecords_emptyAction, importRecords_backendAction, importRecords_normalizeAction, importRecords_normalizeRows, importRecords_rowsFromAnswer, importRecords_emptyHint, importRecords_run,
}
